import http from '@/utils/http'

export function getCards(params){
    return  http('/getCards',{params})
}
export function getCardsUser(params){
    return  http('/getCardsUser',{params})
}
export function getCardShop(params){
    return  http('/getCardShop',{params})
}
export function indexTitle(){
    return  http('/indexTitle')
}
export function getCardTitleList(){
    return  http('/getCardTitleList')
}
export function getUserCardsRoleNum(){
    return  http('/getUserCardsRoleNum')
}
export function getCardsNumUser(params){
    return  http('/getCardsNumUser',{params})
}
export function saveCardsUser(params){
    return  http.post('/saveCardsUser',params)
}
export function buyCard(params){
    return  http.post('/buyCard',params)
}
export function indexProperty(){
    return  http('/indexProperty')
}